import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { name: "form" }
const _hoisted_4 = { class: "contain row" }
const _hoisted_5 = {
  key: 1,
  class: "page-container card col-md-8"
}
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "col-md-12 p-4" }
const _hoisted_8 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "File ID:")
], -1)
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "row mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Conso Group:")
], -1)
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "row mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Balance Sheet Date:")
], -1)
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "row mb-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Currency:")
], -1)
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_21 = { class: "col-md-3" }
const _hoisted_22 = { class: "col-md-9" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "d-flex align-items-center col-md-12" }
const _hoisted_25 = { class: "col-md-3" }
const _hoisted_26 = { class: "col-md-9" }
const _hoisted_27 = {
  key: 1,
  class: "row mb-3"
}
const _hoisted_28 = { class: "col-md-12" }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { class: "row mb-3" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Created By:")
], -1)
const _hoisted_32 = { class: "col-md-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Created Date:")
], -1)
const _hoisted_34 = { class: "col-md-3" }
const _hoisted_35 = { class: "row mb-3" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Finalised By:")
], -1)
const _hoisted_37 = { class: "col-md-3" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Finalised Date:")
], -1)
const _hoisted_39 = { class: "col-md-3" }
const _hoisted_40 = { class: "row mb-3" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Status:")
], -1)
const _hoisted_42 = {
  class: "col-md-3",
  style: {"padding":"0.5rem 1rem"}
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Template Version:")
], -1)
const _hoisted_44 = { class: "col-md-3" }
const _hoisted_45 = { class: "row mb-3" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, null, -1)
const _hoisted_47 = { class: "d-flex col-md-6" }
const _hoisted_48 = {
  key: 1,
  class: "p-1"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_52 = {
  key: 0,
  class: "d-flex col-md-3"
}
const _hoisted_53 = {
  key: 1,
  class: "row mb-3"
}
const _hoisted_54 = { class: "col-md-12" }
const _hoisted_55 = {
  key: 2,
  class: "row mb-3"
}
const _hoisted_56 = { class: "col-md-12" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("p", null, " The system is calculating, please do not refresh the page or close the window while calculating. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheSidebar = _resolveComponent("TheSidebar")!
  const _component_ThePageLoading = _resolveComponent("ThePageLoading")!
  const _component_ThePageHeader = _resolveComponent("ThePageHeader")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TheLoading = _resolveComponent("TheLoading")!
  const _component_InlineMessage = _resolveComponent("InlineMessage")!
  const _component_TheSheetsDialog = _resolveComponent("TheSheetsDialog")!
  const _component_ThePageError = _resolveComponent("ThePageError")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_spam = _resolveComponent("spam")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TheSidebar),
            (_ctx.isPageLoading)
              ? (_openBlock(), _createBlock(_component_ThePageLoading, { key: 0 }))
              : _createCommentVNode("", true),
            (!_ctx.isPageLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_ThePageHeader, {
                    onDeleteEvent: _ctx.openDeleteDialog,
                    onImportEvent: _ctx.importFile,
                    onExportEvent: _ctx.exportFile,
                    renderDelete: (!_ctx.isViewer && _ctx.companyReport.status != '' ? true : false),
                    renderImport: (!_ctx.isViewer && _ctx.companyReport.status == 'Created' ? true : false),
                    importTooltip: "Import Manual Input Cells",
                    renderExport: (!_ctx.isViewer && _ctx.companyReport.status != '' ? true : false),
                    exportTooltip: "Export Manual Input Cells",
                    isDeleting: _ctx.isDeleting,
                    isImporting: _ctx.isImporting,
                    isExporting: _ctx.isExporting
                  }, null, 8, ["onDeleteEvent", "onImportEvent", "onExportEvent", "renderDelete", "renderImport", "renderExport", "isDeleting", "isImporting", "isExporting"]),
                  (_ctx.pageError == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          (_ctx.identifier != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _hoisted_9,
                                _createElementVNode("div", _hoisted_10, [
                                  _createVNode(_component_InputText, {
                                    modelValue: _ctx.companyReport.fileId,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyReport.fileId) = $event)),
                                    disabled: ""
                                  }, null, 8, ["modelValue"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_Dropdown, {
                                options: _ctx.consoGroups,
                                optionLabel: "name",
                                optionValue: "identifier",
                                filter: "",
                                filterFields: ['name'],
                                showClear: "",
                                placeholder: _ctx.isConsoGroupLoading ? ('Loading...') : '-- Please Select --',
                                loading: _ctx.isConsoGroupLoading,
                                modelValue: _ctx.companyReport.consoGroup.identifier,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.companyReport.consoGroup.identifier) = $event)),
                                disabled: _ctx.identifier != null,
                                onChange: _ctx.onConsoGroupChange
                              }, null, 8, ["options", "placeholder", "loading", "modelValue", "disabled", "onChange"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(_component_Calendar, {
                                dateFormat: "yy-mm-dd",
                                manualInput: true,
                                placeholder: "Balance Sheet Date",
                                modelValue: _ctx.companyReport.balanceSheetDate,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.companyReport.balanceSheetDate) = $event)),
                                disabled: _ctx.identifier != null
                              }, null, 8, ["modelValue", "disabled"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _hoisted_18,
                            _createElementVNode("div", _hoisted_19, [
                              _createVNode(_component_Dropdown, {
                                options: _ctx.currencies,
                                optionLabel: "code",
                                optionValue: "identifier",
                                filter: "",
                                filterFields: ['code', 'name'],
                                showClear: "",
                                placeholder: "-- Please Select --",
                                modelValue: _ctx.companyReport.currency.identifier,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.companyReport.currency.identifier) = $event)),
                                disabled: _ctx.identifier != null
                              }, {
                                value: _withCtx((slotProps) => [
                                  (slotProps.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.filterCurrencyCodeByValue(slotProps.value)), 1),
                                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.filterCurrencyNameByValue(slotProps.value)), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(slotProps.placeholder), 1))
                                ]),
                                option: _withCtx((slotProps) => [
                                  _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("span", _hoisted_25, _toDisplayString(slotProps.option.code), 1),
                                    _createElementVNode("span", _hoisted_26, _toDisplayString(slotProps.option.name), 1)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["options", "modelValue", "disabled"])
                            ])
                          ]),
                          (_ctx.identifier != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                  _createVNode(_component_Divider, { type: "solid" })
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.identifier != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _createElementVNode("div", _hoisted_30, [
                                  _hoisted_31,
                                  _createElementVNode("div", _hoisted_32, [
                                    _createVNode(_component_InputText, {
                                      class: "p-inputtext",
                                      type: "text",
                                      maxlength: "50",
                                      modelValue: _ctx.companyReport.createdBy,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.companyReport.createdBy) = $event)),
                                      readonly: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _hoisted_33,
                                  _createElementVNode("div", _hoisted_34, [
                                    _createVNode(_component_InputText, {
                                      class: "p-inputtext",
                                      type: "text",
                                      maxlength: "50",
                                      modelValue: _ctx.companyReport.createdDate,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.companyReport.createdDate) = $event)),
                                      readonly: ""
                                    }, null, 8, ["modelValue"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                  _hoisted_36,
                                  _createElementVNode("div", _hoisted_37, [
                                    _createVNode(_component_InputText, {
                                      class: "p-inputtext",
                                      type: "text",
                                      maxlength: "50",
                                      modelValue: _ctx.companyReport.submissionBy,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.companyReport.submissionBy) = $event)),
                                      readonly: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _hoisted_38,
                                  _createElementVNode("div", _hoisted_39, [
                                    _createVNode(_component_InputText, {
                                      class: "p-inputtext",
                                      type: "text",
                                      maxlength: "50",
                                      modelValue: _ctx.companyReport.submissionDate,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.companyReport.submissionDate) = $event)),
                                      readonly: ""
                                    }, null, 8, ["modelValue"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_40, [
                                  _hoisted_41,
                                  _createElementVNode("div", _hoisted_42, [
                                    _createVNode(_component_Badge, {
                                      class: _normalizeClass(["mr-2", [_ctx.companyReport.status == 'Accepted' || _ctx.companyReport.status == 'Finalised' ? 'p-badge-success' : (_ctx.companyReport.status == 'Rejected' || _ctx.companyReport.status == 'Cancelled' ? 'p-badge-danger' : (_ctx.companyReport.status == 'Submitted' ? 'p-badge-primary' : 'p-badge-warning'))]]),
                                      value: _ctx.companyReport.status
                                    }, null, 8, ["class", "value"])
                                  ]),
                                  _hoisted_43,
                                  _createElementVNode("div", _hoisted_44, [
                                    _createVNode(_component_InputText, {
                                      class: "p-inputtext",
                                      type: "text",
                                      maxlength: "50",
                                      modelValue: _ctx.companyReport.templateVersion,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.companyReport.templateVersion) = $event)),
                                      readonly: ""
                                    }, null, 8, ["modelValue"])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_45, [
                            _hoisted_46,
                            _createElementVNode("div", _hoisted_47, [
                              (_ctx.identifier == null)
                                ? (_openBlock(), _createBlock(_component_Button, {
                                    key: 0,
                                    class: "p-button-sm",
                                    disabled: _ctx.v$.companyReport.$invalid || _ctx.isLoading || (_ctx.identifier != null && _ctx.companyReport.status != 'Created'),
                                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.save())),
                                    label: "Save"
                                  }, null, 8, ["disabled"]))
                                : _createCommentVNode("", true),
                              (_ctx.identifier != null)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_48))
                                : _createCommentVNode("", true),
                              (_ctx.identifier != null)
                                ? (_openBlock(), _createBlock(_component_Button, {
                                    key: 2,
                                    class: "p-button-sm",
                                    disabled: _ctx.v$.companyReport.$invalid || _ctx.isLoading || _ctx.isImporting || _ctx.isExporting || _ctx.isDeleting || (_ctx.identifier != null && _ctx.companyReport.status != 'Created'),
                                    hidden: _ctx.isViewer,
                                    onClick: _ctx.submit,
                                    label: "Finalise"
                                  }, null, 8, ["disabled", "hidden", "onClick"]))
                                : _createCommentVNode("", true),
                              _hoisted_49,
                              (_ctx.identifier != null && (!_ctx.isAdminPortal && (_ctx.isAdmin || _ctx.isHQStaff)))
                                ? (_openBlock(), _createBlock(_component_Button, {
                                    key: 3,
                                    class: "p-button-sm",
                                    disabled: _ctx.v$.companyReport.$invalid || _ctx.isLoading || _ctx.isImporting || _ctx.isExporting || _ctx.isDeleting || (_ctx.identifier != null && _ctx.companyReport.status != 'Finalised'),
                                    hidden: _ctx.isViewer,
                                    onClick: _ctx.unfinalise,
                                    label: "Unfinalise"
                                  }, null, 8, ["disabled", "hidden", "onClick"]))
                                : _createCommentVNode("", true),
                              _hoisted_50,
                              _createVNode(_component_Button, {
                                class: "p-button-sm p-button-secondary",
                                onClick: _ctx.cancel,
                                label: "Cancel"
                              }, null, 8, ["onClick"]),
                              _hoisted_51,
                              (_ctx.isLoading)
                                ? (_openBlock(), _createBlock(_component_TheLoading, { key: 4 }))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.identifier != null)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                  _createVNode(_component_Button, {
                                    class: "p-button-sm",
                                    label: 'Configuration',
                                    onClick: _ctx.showDetailDialog,
                                    disabled: _ctx.isLoading
                                  }, null, 8, ["onClick", "disabled"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.identifier != null && _ctx.isCWKLoaded)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _createVNode(_component_InlineMessage, {
                            severity: "info",
                            class: "d-block"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("CWK is currenly loaded in a CWK: " + _toDisplayString(_ctx.loadedInFileId), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.identifier != null && _ctx.staleChildren.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.staleChildren, (detail, index) => {
                            return (_openBlock(), _createBlock(_component_InlineMessage, {
                              key: index,
                              severity: "warn",
                              class: "d-block mb-2"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(detail.referenceCode) + " - " + _toDisplayString(detail.referenceName) + " (" + _toDisplayString(detail.referenceFileId) + ") was loaded on " + _toDisplayString(detail.lastModifiedDate) + ", before it was finalised on " + _toDisplayString(detail.referenceSubmissionDate) + ". Its data may have changed - please reload. ", 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_TheSheetsDialog, {
                    identifier: _ctx.dialog.identifier,
                    name: _ctx.dialog.consoGroupName,
                    type: 'cwk',
                    balanceSheetDate: _ctx.dialog.balanceSheetDate == null ? null : _ctx.formatToDate(_ctx.dialog.balanceSheetDate),
                    currencyCode: _ctx.dialog.currencyCode,
                    id: _ctx.dialog.id,
                    templateIndex: _ctx.dialog.templateIndex,
                    status: _ctx.dialog.status,
                    visible: _ctx.dialog.visible,
                    loading: _ctx.dialog.loading,
                    isUnsaved: _ctx.dialog.isUnsaved,
                    reportSheets: _ctx.dialog.companyReportSheets,
                    onSave: _ctx.updateSheets,
                    onAutoSave: _ctx.updateSheetCached,
                    onDeleteCached: _ctx.deleteSheetCached,
                    onCancel: _ctx.closeDialog
                  }, null, 8, ["identifier", "name", "balanceSheetDate", "currencyCode", "id", "templateIndex", "status", "visible", "loading", "isUnsaved", "reportSheets", "onSave", "onAutoSave", "onDeleteCached", "onCancel"]),
                  (_ctx.pageError != '')
                    ? (_openBlock(), _createBlock(_component_ThePageError, {
                        key: 3,
                        onBackEvent: _ctx.cancel,
                        pageError: _ctx.pageError
                      }, null, 8, ["onBackEvent", "pageError"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_TheFooter)
          ])
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.isCalculating,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isCalculating) = $event)),
      header: "Calculating",
      modal: "",
      style: { width: '40vw' },
      closable: false
    }, {
      footer: _withCtx(() => [
        (_ctx.isCalculating)
          ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _hoisted_57
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.isDeleteConfirmation,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.isDeleteConfirmation) = $event)),
      header: "Confirmation to delete",
      modal: "",
      style: { width: '30vw' }
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No",
          icon: "pi pi-times",
          onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.isDeleteConfirmation=false;}),
          class: "p-button-text"
        }),
        (_ctx.isEmptyCWK)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              label: "Yes",
              icon: "pi pi-check",
              onClick: _ctx.deleteCompanyReport
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", null, [
          (_ctx.isEmptyCWK)
            ? (_openBlock(), _createBlock(_component_spam, { key: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode(" Are you sure want to delete this CWK? ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isEmptyCWK)
            ? (_openBlock(), _createBlock(_component_spam, { key: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode(" Unable to delete. Unload all items or restructure before deleting. ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}